import { Home, Calculator, Users, ReceiptText, Droplets, Landmark, Music, Car, Briefcase, Scale, Sparkles } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow, SectionShell } from "./Reveal";

const icons = [Home, Calculator, Users, ReceiptText, Droplets, Landmark, Music, Car, Briefcase, Scale, Sparkles];

export default function FundsUse() {
  const { t } = useLang();

  return (
    <SectionShell id="fondi" testid="use-of-funds-section">
      <Reveal className="text-center">
        <Eyebrow>{t.funds.eyebrow}</Eyebrow>
        <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
          {t.funds.title}
        </h2>
      </Reveal>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {t.funds.items.map((item, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={i} delay={Math.min(i * 0.05, 0.3)}>
              <div
                data-testid={`funds-item-${i + 1}`}
                className="group flex items-start gap-4 h-full rounded-2xl border border-slate-200 bg-white p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all"
              >
                <span className="grid place-items-center h-10 w-10 shrink-0 rounded-xl bg-sky-600/10 text-sky-600 group-hover:bg-sky-600 group-hover:text-white transition-colors">
                  <Icon size={18} />
                </span>
                <p className="text-sm text-slate-600 leading-relaxed pt-1.5">{item}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </SectionShell>
  );
}
